var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1094 5.50983L17.3594 9.69983C18.2846 10.2365 18.8541 11.2252 18.8541 12.2948C18.8541 13.3644 18.2846 14.3531 17.3594 14.8898L10.1094 19.0798C9.18088 19.6159 8.03687 19.6157 7.10854 19.0794C6.18021 18.543 5.60869 17.552 5.60938 16.4798V8.10983C5.60869 7.03769 6.18021 6.04668 7.10854 5.51031C8.03687 4.97395 9.18088 4.97376 10.1094 5.50983ZM9.20938 17.5198L16.4594 13.3398C16.8324 13.1269 17.0617 12.7294 17.0594 12.2998C17.0633 11.8673 16.834 11.4661 16.4594 11.2498L9.20938 7.06983C9.02805 6.96084 8.82094 6.90216 8.60938 6.89983C7.94111 6.89983 7.39938 7.44157 7.39938 8.10983V16.4798C7.39938 16.8007 7.52686 17.1085 7.75378 17.3354C7.9807 17.5624 8.28847 17.6898 8.60938 17.6898C8.82094 17.6875 9.02805 17.6288 9.20938 17.5198Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.2daa5703c31349f169de9e03e1633adc.svg";
export { ForwardRef as ReactComponent };